import {
  Component,
  OnInit,
  ViewChild,
  Input,
  EventEmitter,
  Output,
  OnChanges,
} from '@angular/core'
import { MatAccordion } from '@angular/material/expansion'
import { QuoteCheckoutService } from '../../services/quote-checkout.service'
import { QuoteCartService } from '../../../quote-services/quote-cart.service'
import { AuthService, User } from '@spartacus/core'
import { Observable, of } from 'rxjs'
import { Router } from '@angular/router'
import { switchMap } from 'rxjs/operators'
import {
  FormBuilder,
  FormGroup,
  FormControl,
  Validators,
  FormControlName,
} from '@angular/forms'
import { QuoteDataService } from '../../services/quote-data.service'
import { Cart } from '../../model/cart-model'
import { UserAccountFacade } from '@spartacus/user/account/root'
import { QuoteStatus } from '../../../../../models/status/status.model'

@Component({
  standalone: false,
  selector: 'vs-loggedIn-user-checkout',
  templateUrl: './loggedIn-user-checkout.component.html',
  styleUrls: ['./loggedIn-user-checkout.component.scss'],
})
export class LoggedInUserCheckoutComponent implements OnInit, OnChanges {
  @ViewChild(MatAccordion) accordion: MatAccordion
  @Input() orderType
  @Input() rfqTypes
  @Input() orderChanged
  @Input() isSubmitted
  @Input() cartData: Cart
  @Output() cartUpdate = new EventEmitter<any>()
  @Output() updateFile = new EventEmitter<any>()
  step = 0
  panelOpenState = true
  panelOpenStatex = true
  isToggle = false
  userIndustries = []
  user$: Observable<User>
  userType: string
  isLoggedinUser = false
  endUserData$: Observable<any>
  endUserIndustries: any
  selectedEndUserIndustry: any
  userAddressData: any
  userAddressData$: Observable<any>
  loggedInNotificationsForm: FormGroup
  loggedInSoldToAddressForm: FormGroup
  cartId: string
  soldToAddress: any
  shipToAddress: any
  endCountry: any
  public legalEntity: string
  complienceQuestions
  showComplienceQuestionaire: boolean
  endCustomerAddress: {
    firstName: any
    lastName: any
    companyName: any
    line1: any
    line2: any
    town: any
    name: any
    postalCode: any
  }
  loggedIn = true
  legalEntityData: any
  showComplienceQues: boolean
  billToValidation: boolean
  complienceValidation: boolean
  endUserValidation: boolean
  deliveryValidation: boolean
  warningFlagText
  y
  QuoteStatus = QuoteStatus
  readOnly: boolean = false
  constructor(
    private fb: FormBuilder,
    private quoteCheckoutService: QuoteCheckoutService,
    private quoteService: QuoteCartService,
    private auth: AuthService,

    private router: Router,
    public data: QuoteDataService,
    private userAccountFacade: UserAccountFacade
  ) {
    this.loggedInSoldToAddressForm = this.fb.group({
      firstName: new FormControl(),
      lastName: new FormControl(),
      companyName: new FormControl(),
      line1: new FormControl(),
      town: new FormControl(),
      name: new FormControl(),
      postalCode: new FormControl(),
    })
  }

  ngOnInit(): void {
    this.data.recieveBillToAddressValidation.subscribe((valid: boolean) => {
      this.billToValidation = valid
    })
    this.data.recieveComplienceValidation.subscribe((valid: boolean) => {
      this.complienceValidation = valid
    })
    this.data.recieveEndUserAddressValidation.subscribe((valid: boolean) => {
      this.endUserValidation = valid
    })
    this.data.recieveDeliveryAddressValidation.subscribe((valid: boolean) => {
      this.deliveryValidation = valid
    })
    this.user$ = this.auth.isUserLoggedIn().pipe(
      switchMap((isUserLoggedIn) => {
        if (isUserLoggedIn) {
          this.userType = 'current'
          return this.userAccountFacade.get()
        } else {
          this.userType = 'anonymous'
          return of(undefined)
        }
      })
    )
    this.auth.isUserLoggedIn().subscribe((success) => {
      if (success) {
        this.isLoggedinUser = success
        this.userType = 'current'
      } else {
        this.userType = 'anonymous'
      }
    })
    this.loggedInNotificationsForm = this.fb.group({
      quoteAcknowledge: new FormControl(null, [
        Validators.required,
        Validators.pattern(
          /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        ),
      ]),
    })
    this.legalEntity = this.cartData?.legalEntity
    this.loggedInNotificationsForm.controls['quoteAcknowledge'].setValue(
      this.cartData?.notificationEmail
    )
    if (this.cartData?.quoteCartType == QuoteStatus.EDIT) {
      if (this.cartData?.notificationEmail) {
        // this.loggedInNotificationsForm.controls.quoteAcknowledge.disable();
        this.readOnly = true
        this.loggedInNotificationsForm.controls['quoteAcknowledge'].setValue(
          this.cartData?.notificationEmail
        )
      }
    }
    this.data.sendNotificationValidation(
      this.loggedInNotificationsForm.controls['quoteAcknowledge'].valid
    )
    this.loggedInNotificationsForm.valueChanges.subscribe((data) => {
      this.cartData.notificationEmail = data.quoteAcknowledge
      this.data.sendNotificationValidation(
        this.loggedInNotificationsForm.controls['quoteAcknowledge'].valid
      )
      this.cartUpdate.emit(this.cartData)
    })
    // soldToAddress Form
    this.selectedEndUserIndustry = 'Select'
    this.getEndUserIndustry()
    this.getUserAddress()
    this.getLegalEntity()
    this.endCountryData(this.cartData?.endUserAddress?.country?.isocode)
    if (this.cartData?.attachments) {
      this.data.sendAttachments(this.cartData?.attachments)
    }

    this.showComplienceQuestions()
    this.quoteCheckoutService.checkSubmission.subscribe((data) => {
      if (
        data === true &&
        this.complienceValidation &&
        this.cartData?.endUserIndustry &&
        this.cartData?.rfqType
      ) {
        this.scrollToError()
      }
      if (
        data === true &&
        !this.showComplienceQues &&
        this.cartData?.endUserIndustry &&
        this.cartData?.rfqType
      ) {
        // this.scrollToError();
      }
    })
  }

  scrollToError(): void {
    const firstElementWithError = document.querySelector(
      '.ng-invalid[formControlName]'
    )
    this.scrollTo(firstElementWithError)
  }
  scrollTo(el: Element): void {
    if (el) {
      el.scrollIntoView({ behavior: 'smooth', block: 'center' })
      el.parentElement.focus()
    }
  }
  get quoteAcknowledge() {
    return this.loggedInNotificationsForm.get('quoteAcknowledge')
  }
  toggleButton() {
    this.isToggle = !this.isToggle
  }
  ngOnChanges(changes) {}
  setStep(index: number) {
    this.step = index
  }

  nextStep() {
    this.step++
  }

  prevStep() {
    this.step--
  }
  showComplienceQuestions() {
    var showCount = 0
    //coonsole.log(this.legalEntityData, this.cartData?.endUserAddress?.country?.isocode, this.cartData?.legalEntity)
    this.legalEntityData?.forEach((element) => {
      if (
        element.code == this.cartData?.legalEntity &&
        element.salesAreaAddress?.country?.isocode ==
          this.cartData?.endUserAddress?.country?.isocode
      ) {
        showCount = showCount + 1
      } else {
      }
    })
    if (showCount > 0) {
      this.showComplienceQues = false
    } else {
      this.showComplienceQues = true
    }
  }
  getLegalEntity() {
    const legalEntity = 'legalEntity'
    this.quoteCheckoutService
      .getLegalEntity('current')
      .subscribe((data: any) => {
        this.legalEntityData = data[legalEntity]
        this.showComplienceQuestions()
      })
  }
  getEndUserIndustry() {
    const endUserIndustries = 'endUserIndustries'
    const urlParam = [endUserIndustries]
    this.endUserData$ = this.quoteCheckoutService.getEndUserIndustry(
      this.userType
    )
    this.endUserData$.subscribe((data: any) => {
      this.endUserIndustries = data[endUserIndustries]
    })
  }

  getUserAddress() {
    this.soldToAddress = {
      firstName: this.cartData?.billToAddress.firstName,
      lastName: this.cartData?.billToAddress.lastName,
      companyName: this.cartData?.billToAddress.companyName,
      line1: this.cartData?.billToAddress?.line1,
      line2: this.cartData?.billToAddress?.line2,
      town: this.cartData?.billToAddress?.town,
      country: this.cartData?.billToAddress?.country?.name,
      postalCode: this.cartData?.billToAddress?.postalCode,
    }
    this.data.sendBillToAddressValidation(true)
    this.shipToAddress = {
      firstName: this.cartData?.deliveryAddress?.firstName,
      lastName: this.cartData?.deliveryAddress?.lastName,
      companyName: this.cartData?.deliveryAddress?.companyName,
      line1: this.cartData?.deliveryAddress?.line1,
      line2: this.cartData?.deliveryAddress?.line2,
      town: this.cartData?.deliveryAddress?.town,
      name: this.cartData?.deliveryAddress?.country?.name,
      postalCode: this.cartData?.deliveryAddress?.postalCode,
    }
    this.endCustomerAddress = {
      firstName: this.cartData?.endUserAddress?.firstName,
      lastName: this.cartData?.endUserAddress?.lastName,
      companyName: this.cartData?.endUserAddress?.companyName,
      line1: this.cartData?.endUserAddress?.line1,
      line2: this.cartData?.endUserAddress?.line2,
      town: this.cartData?.endUserAddress?.town,
      name: this.cartData?.endUserAddress?.country?.name,
      postalCode: this.cartData?.endUserAddress?.postalCode,
    }
    this.complienceQuestions = {
      restrictedCountryCheck: this.cartData?.restrictedCountryCheck,
      sanctionCheck: this.cartData?.sanctionCheck,
      requiresExportLicense: this.cartData?.requiresExportLicense,
      isNuclear: this.cartData?.isNuclear,
      hasRestrictedUse: this.cartData?.hasRestrictedUse,
      customerReviewCheck: this.cartData?.customerReviewCheck,
      restrictedPartList: this.cartData?.restrictedPartList,
      warningFlags: this.cartData?.warningFlags,
      governmentParties: this.cartData?.governmentParties,
    }
    this.warningFlagText = this.cartData?.warningFlagText
    this.endCountry = this.cartData?.endUserAddress?.country?.isocode
    // this.data.setSoldAddressDataNew(this.soldToAddress)
  }
  endCountryData(event) {
    this.endCountry = event
    if (
      (this.endCountry === 'FR' && this.cartData?.legalEntity === '6260') ||
      (this.endCountry === 'US' && this.cartData?.legalEntity === '1810') ||
      (this.endCountry === 'IN' && this.cartData?.legalEntity == '5500') ||
      (this.endCountry === null && this.cartData?.legalEntity === null)
    ) {
      this.showComplienceQuestionaire = false
    } else {
      this.showComplienceQuestionaire = true
    }
  }
  deliveryAddressUpdate(event) {
    this.cartData.deliveryAddress = event
    this.cartUpdate.emit(this.cartData)
  }
  endCustomerAddressUpdate(event) {
    this.cartData.endUserAddress = event

    this.showComplienceQuestions()
    this.cartUpdate.emit(this.cartData)
  }
  endUserIndustryUpdate(event) {
    if (event) {
      this.cartData.endUserIndustry = event
      this.cartUpdate.emit(this.cartData)
    }
  }
  // tslint:disable-next-line: adjacent-overload-signatures
  complienceQuestionsUpdates(event) {
    this.cartData.customerReviewCheck = event.customerReviewCheck
    this.cartData.hasRestrictedUse = event.hasRestrictedUse
    this.cartData.isNuclear = event.isNuclear
    this.cartData.requiresExportLicense = event.requiresExportLicense
    this.cartData.restrictedCountryCheck = event.restrictedCountryCheck
    this.cartData.sanctionCheck = event.sanctionCheck
    this.cartData.restrictedPartList = event.restrictedPartList
    this.cartData.warningFlags = event.warningFlags
    this.cartData.governmentParties = event.governmentParties
    this.cartUpdate.emit(this.cartData)
  }
  updateFiles(event) {
    this.updateFile.emit(event)
  }
  warningFlagTextUpdate(event) {
    this.warningFlagText = event
    this.cartData.warningFlagText = event
    this.cartUpdate.emit(this.cartData)
  }
}
